import { jobPayloadState } from "_state/atoms/AppAtoms";
import { sectorDict } from "config/Consts";
import moment from "moment";
import { useSetRecoilState } from "recoil";

export const jobPostTime = (jobCreatedTime: Date): string => {
  if (jobCreatedTime.toString() === "Invalid Date") return "null";

  // const time = moment.utc(jobCreatedTime).format("YYYY-MM-DDTHH:mm:ss");
  const time = moment(jobCreatedTime).utcOffset("-5:00");

  // const time = moment.utc(jobCreatedTime);
  return moment(time).fromNow();
};

interface IGetJobCategoryScores {
  jobType: string;
  preferenceScores?: any;
  aiScores?: any;
}

interface IRequiredJobScore {
  preferenceScore?: number;
  aiScore?: number;
}
export const GetJobCategoryScores = ({
  jobType,
  preferenceScores,
  aiScores,
}: IGetJobCategoryScores): IRequiredJobScore => {
  const requiredJobScore: IRequiredJobScore = {};

  for (const jobCategories in aiScores) {
    if (jobType?.toUpperCase() === jobCategories?.toUpperCase())
      requiredJobScore.aiScore = aiScores[jobCategories];
  }

  return requiredJobScore;
};

export const SetJobFilterPayload = (
  fieldName: string,
  fieldValue: string | number | any[]
): void => {
  const setPayload = useSetRecoilState(jobPayloadState);
  setPayload((prev: any) => {
    prev[fieldName] = fieldValue;
    return { ...prev };
  });
};

export const searchZipPos = (
  codes: readonly number[],
  target: number
): number => {
  let left = 0;
  let right = codes.length - 1;
  let resultIndex = -1;

  while (left < right) {
    const mid = left + Math.floor((right - left) / 2);
    if (codes[mid] === target) {
      resultIndex = mid;
      break;
    } else if (codes[mid] < target) left = mid + 1;
    else right = mid - 1;
  }

  return resultIndex > -1 ? resultIndex : left;
};

interface IGetZipListParams {
  codes: readonly number[];
  targetIdx: number;
  value: string;
}

export const getZipList = ({
  codes,
  targetIdx,
  value,
}: IGetZipListParams): number[] => {
  const result = [];
  for (let i = targetIdx; i < codes.length; i++) {
    const code = codes[i].toString();
    let isMatch = true;
    for (let j = 0; j < value.length; j++) {
      if (value[j] !== code[j]) isMatch = false;
    }
    if (isMatch) result.push(codes[i]);
  }
  return result;
};

/**
 * @description update job saved status in allJobs[]
 * @param setAllJobs -> set the jobs with updated status
 * @param isSaved -> status of the job
 * @param index => index number of job for which status going to be changed
 */

export const updateJobSavedStatus = ({
  isSaved,
  setAllJobs,
  index,
}: {
  isSaved: boolean;
  setAllJobs: undefined | ((arg?: any) => void);
  index?: number;
}): void => {
  setAllJobs?.((prev: any) => {
    const temp = [...prev];
    try {
      temp[index ?? -1].job.isSaved = isSaved;
    } catch (e) {
      console.error("can't update saved job");
    }

    return temp;
  });
};

export const updateJobAppliedStatus = ({
  isApplied,
  isNotInterested,
  setAllJobs,
  index,
}: {
  isApplied: boolean;
  isNotInterested: boolean;
  setAllJobs: undefined | ((arg?: any) => void);
  index: number;
}): void => {
  setAllJobs?.((prev: any) => {
    const temp = prev.map((el: any) => {
      return {
        ...el,
        job: { ...el.job },
      };
    });

    if (temp[index]?.job as boolean) {
      temp[index].job.isApplied = isApplied;
      temp[index].job.notInterested = isNotInterested;
    }
    return temp;
  });
};

export const getSectorId = (sector: string): number => {
  for (let i = 0; i < sectorDict.length; i++) {
    if (sectorDict[i] === sector) return i;
  }
  return -1;
};

export const sortObject = (obj: any): any => {
  const sortable = Object.entries(obj)
    .sort(([, a], [, b]) => (b as number) - (a as number))
    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
  return sortable;
};
